module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "smashing-plates.7136aa41.webp";